import { render, staticRenderFns } from "./ComponentTab.vue?vue&type=template&id=da9f5c14"
import script from "./ComponentTab.vue?vue&type=script&lang=js"
export * from "./ComponentTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da9f5c14')) {
      api.createRecord('da9f5c14', component.options)
    } else {
      api.reload('da9f5c14', component.options)
    }
    module.hot.accept("./ComponentTab.vue?vue&type=template&id=da9f5c14", function () {
      api.rerender('da9f5c14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/reporting/ComponentTab.vue"
export default component.exports